<template>
  <v-radio-group v-model="modelValue" :column="column" :class="groupClass">
    <RadioInput
      v-for="{ label, value } in items"
      :key="value"
      :label="label"
      :value="value"
      :as-btn="true"
    />
  </v-radio-group>
</template>

<script>
import { RADIO_INPUT_TYPES } from '../../../consts'
import { isUndefinedOrNull } from '../../../services/UtilService'
import RadioInput from './RadioInput.vue'

export default {
  name: 'RadioGroup',
  components: {
    RadioInput
  },
  props: {
    value: {
      type: RADIO_INPUT_TYPES,
      required: true
    },
    items: {
      type: Array,
      required: true,
      validator: (val) => {
        return val.every((item) => {
          return (
            !isUndefinedOrNull(item.label) && !isUndefinedOrNull(item.value)
          )
        })
      }
    },
    column: {
      type: Boolean
    },
    shouldShowMsgs: {
      type: Boolean
    }
  },
  emits: ['input'],
  computed: {
    modelValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    groupClass () {
      return {
        'no-msgs': !this.shouldShowMsgs,
        column: this.column
      }
    }
  }
}
</script>

<style lang="scss">

.v-input--radio-group {
  margin-bottom: 3px;
}

.column .v-input--radio-group__input{
  gap: 12px;
}
.v-input--radio-group__input {
  gap: 28px;
}

.no-msgs {
  .v-messages {
    display: none
  }
}
</style>



// WEBPACK FOOTER //
// src/components/globalUiComponents/radio/RadioGroup.vue